var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourWeekPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.3846,
    y: 27.7692,
    width: 39.2308,
    height: 39.2308,
    rx: 5,
    stroke: "#36AFC1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3846 38.6666H67.6155",
    stroke: "#36AFC1",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8078 24.4999L57.8078 31.0384",
    stroke: "#36AFC1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1923 24.4999L38.1923 31.0384",
    stroke: "#36AFC1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0128 47.3845H38.1923",
    stroke: "#36AFC1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9102 47.3845H49.0896",
    stroke: "#36AFC1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8077 47.3845H59.9872",
    stroke: "#36AFC1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0128 56.1025H38.1923",
    stroke: "#36AFC1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9102 56.1025H49.0896",
    stroke: "#36AFC1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8077 56.1025H59.9872",
    stroke: "#36AFC1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 83,
    height: 83,
    rx: 41.5,
    stroke: "url(#paint0_linear_2444_86026)",
    strokeWidth: 5,
    shapeRendering: "geometricPrecision"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2444_86026",
    x1: -13.546,
    y1: 40,
    x2: 108.532,
    y2: 63.3793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523687,
    stopColor: "#56CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107D8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourWeekPlans);
export default __webpack_public_path__ + "static/media/four-week-plans.fcf02065e858f589606c8d5a8da7f4b7.svg";
export { ForwardRef as ReactComponent };